/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolHardWrenchIcon16Solid = forwardRef('ToolHardWrenchIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.428 5.69a.875.875 0 0 1 0-1.237l2.46-2.46c.24-.241.173-.648-.152-.753a4.711 4.711 0 0 0-5.84 6.213L1.519 11.83a1.877 1.877 0 1 0 2.654 2.654l4.379-4.378a4.711 4.711 0 0 0 6.21-5.836c-.105-.326-.512-.394-.754-.152L11.55 6.576a.875.875 0 0 1-1.237 0l-.885-.885Z" })));
});
